import { useCallback } from 'react';
import { useNCTextLocalizer } from '../../../locale/useNCTextLocalizer';
export const useImageSelectorA11yInfo = () => {
  const localize = useNCTextLocalizer('ImageSelector');
  return useCallback(props => {
    const tooltip = props?.tooltip ?? localize('imageHotSpot.tooltip.label');
    return {
      ariaLabel: props?.ariaLabel ?? tooltip,
      tooltip
    };
  }, [localize]);
};
//# sourceMappingURL=useImageSelectorA11yInfo.js.map